export default __webpack_public_path__ + "static/media/React Sertifikat.cffd0988.png";